<template>
  <main>
    <PageIntro
      :heading="'Your <span>' +configStrings.productName + '</span> account'"
      :body="'<p>You must set a new password.</p>'" />
    <SetNewPasswordForm />
    <FooterShout :type="'signin'"/>
  </main>
</template>

<script>
  import SetNewPasswordForm from '@/components/SetNewPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      SetNewPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>